<template>
  <!-- content - start -->
  <div class="recruit content">
    <div class="banner-sub">
      <img :src="project.banner" alt="">
    </div>
    <div class="wrap">
      <div class="part-details">
        <div class="part-title">
          <h2 v-text="project.title"></h2>
        </div>
        <div class="text-box" v-html="project.detail"></div>
      </div>
    </div>
  </div>
  <!-- content - end -->
</template>

<script>
import {ApiWebIndexProductProjectInfo} from '../api/product'
export default {
  name: 'product',
  data () {
    return {
      subNavFlag: false,
      projectId: null,
      project: {
        id: null,
        title: '',
        imgs: [],
        detail: '',
        banner: null
      }
    }
  },
  mounted () {
    // 接收由其它页面传过来的方案id
    this.projectId = this.$route.params.projectId || this.$store.getters['product/getProjectId']
    this.initProject(this.projectId)
    var swiper = new Swiper('.swiper-container', {
      // pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 4,
      centeredSlides: true,
      paginationClickable: true,
      spaceBetween: 30,
      loop: true
    })
  },
  methods: {
    initProject (id) {
      ApiWebIndexProductProjectInfo(id).then(({data}) => {
        if (data && data.status === 0) {
          this.project = data.data
        }
      })
    },
    /**
     * 打开/关闭  产品推荐导航 操作
     */
    showSubHandler () {
      this.subNavFlag = !this.subNavFlag
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/product-demo.vue